/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-23 16:50:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-09-09 11:16:22
 * @FilePath: /src/app/(payment)/payment/components/Points/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import Button from '@/components/Button';
import Checkbox from '@/components/Form/Checkbox';
import JoinFreeDialog from '@/components/GlobalDialog/JoinFreeDialog';
import Image from '@/components/Image';
import Popup from '@/components/Popup';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { toast } from '@/components/Toast';
import { useStore } from '@/providers/app-store-provider';
import { IS_DE_FR } from '@/utils/constants';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import { CloseOutlined, QuestionFilled, RightArrowOutlined, SuccessFilled } from '@zeelool/icon';
import { useTranslations } from 'next-intl';
import { useEffect, useImperativeHandle, useState } from 'react';
import PointDialog from './components/PointDialog';

interface PointsProps {
  price: any;
  vipEquity: any;
  onUsePoints: (isUse: boolean) => void;
  joinFreeSuccess: () => void;
  ref: React.RefObject<any>;
  showPaymentJoinMember: any;
}

export default function Points(props: PointsProps) {
  const t = useTranslations('payment.Points');
  const { price, vipEquity, onUsePoints, showPaymentJoinMember, ref, joinFreeSuccess } = props;

  // 通过ref 能够更新 当前组件的值
  useImperativeHandle(ref, () => ({
    updateState(state: any) {
      if ('checked' in state) setChecked(state.checked);
      if ('checked' in state) setTempChecked(state.checked);
    },
  }));

  const [checked, setChecked] = useState(false);
  const [tempChecked, setTempChecked] = useState(false);
  const [joinMemberSwitch, setJoinMemberSwitch] = useState(2);
  const [showPointDialog, setShowPointDialog] = useState(false);

  const setJoinFreeDialogInfo = useStore((state) => state.setJoinFreeDialogInfo);

  const [open, setOpen] = useState(false);

  // Sync tempChecked with the current applied state whenever the popup opens
  // so that the popup reflects the latest confirmed selection.
  useEffect(() => {
    if (open) {
      setTempChecked(checked);
    }
  }, [open]);

  const currency = useStore((state) => state.currency);
  const userInfo = useStore((state) => state.userInfo);

  const onJoinFreeSuccess = () => {
    toast.success(t('joinSuccess'));
    joinFreeSuccess();
  };

  useEffect(() => {
    const { show_payment_join_member } = JSON.parse(
      showPaymentJoinMember.payment_join_member.json_value,
    ) as any;
    setJoinMemberSwitch(show_payment_join_member);
  }, []);

  const showPiontDialog = () => {
    setShowPointDialog(true);
  };

  const isJoinMember = userInfo.is_member !== 1 && joinMemberSwitch === 1;
  const isDisabledUsePoints = price?.expend_point === 0 || userInfo.is_member !== 1;
  return (
    <div className="bg-white rounded-[10px] md:rounded-[5px] w-full  mb-[12px] overflow-hidden">
      <WebOnly>
        <div className={` ${isJoinMember ? 'p-0' : 'py-[12px] px-[1.5625vw]'}`}>
          {isJoinMember ? (
            <div className="flex items-center py-[10px] px-[28px] pr-[30px] pb-[19px] bg-white bg-[url('/zeelool-next/payment/join_member_bg@2x.png')] bg-[length:100%_100%] ">
              <div className="text-[#27385F]">
                <span className="block font-bb mb-[6px] text-[14px]">{t('zeeloolRewards')}</span>
                {!!vipEquity?.vip_v0_coupon && Number(vipEquity?.vip_v0_coupon) !== 0 && (
                  <span className="block text-[12px]">
                    {`Get ${formatPriceNumberWithSymbol(vipEquity.vip_v0_coupon, currency)} off and earn points to redeem future orders`}
                  </span>
                )}
              </div>
              <div
                className="ml-auto flex items-center justify-center gap-2 py-[8px] px-[8px] pb-[7px] bg-gradient-to-l from-[#F3CFA0] to-[#FFF0D1] rounded-[15px] cursor-pointer text-[12px] text-[#282828]"
                onClick={() => {
                  setJoinFreeDialogInfo({
                    show: true,
                  });
                }}
              >
                {t('joinForFree')}
                <RightArrowOutlined />
              </div>
            </div>
          ) : (
            <div className={`flex items-center justify-between`}>
              <h3 className="font-bb text-[18px]">{t('redeem')}</h3>
              <span className="flex-1 flex items-center justify-end text-sm text-auxiliary-text">
                ( {price?.point > 1 ? t('myPoints') : t('MyPoint')}: {price?.point}){' '}
                <QuestionFilled onClick={showPiontDialog} className="cursor-pointer ml-2" />
              </span>
            </div>
          )}
          <div className={`flex justify-between items-center ${isJoinMember ? 'px-[18px]' : ''}`}>
            <Checkbox
              checked={checked}
              disabled={isDisabledUsePoints}
              onChange={(e) => {
                setChecked(e.target.checked);
                onUsePoints(e.target.checked);
              }}
              label={t('usePoints', {
                count: price?.expend_point || 0,
                plural:
                  price?.expend_point === 0 || price?.expend_point > 1 ? t('points') : t('point'),
              })}
              className={`${isDisabledUsePoints ? 'cursor-not-allowed' : ''}`}
              icon={
                isDisabledUsePoints ? (
                  <div className="w-[20px] h-[20px] bg-[#e1e1e1] rounded-[50%]" />
                ) : (
                  <div className="w-[20px] h-[20px] rounded-[50%] border-[1.5px] border-[#A9A9A9]" />
                )
              }
              checkedIcon={
                <SuccessFilled
                  className="w-[20px] h-[20px]"
                  style={{ width: '20px', height: '20px' }}
                />
              }
              sx={{
                paddingLeft: 0,
                '& .MuiButtonBase-root': {
                  cursor: isDisabledUsePoints ? 'not-allowed' : 'pointer',
                },
                '& .MuiTypography-root': {
                  color: isDisabledUsePoints ? '#c0c4cc' : '#606266',
                  fontSize: 'max(14px, .8333vw)',
                },
              }}
            />
            <div className="font-bb notranslate">
              -{formatPriceNumberWithSymbol(price?.point_discount, currency)}
            </div>
          </div>
          <div>
            {userInfo.is_member !== 1 && joinMemberSwitch === 2 && (
              <div className="tip">{t('joinZeeloolRewards')}</div>
            )}
          </div>
        </div>
      </WebOnly>

      <WapOnly>
        <div>
          {userInfo.is_member !== 1 ? (
            <div className={`coupon ${joinMemberSwitch === 1 ? 'join-free-wrapper' : ''}`}>
              {joinMemberSwitch === 1 && (
                <div className="w-full ">
                  <div className="bg-[url('/zeelool-next/payment/join_member_bg@2x.png')] bg-[length:100%_100%] flex  justify-between py-[12px] px-[18px]">
                    <div className="text-[#27385F] ">
                      <span className="join-title block font-bb text-[14px]">
                        {t('zeeloolRewards')}
                      </span>
                      {!!vipEquity?.vip_v0_coupon && Number(vipEquity.vip_v0_coupon) !== 0 && (
                        <span className="join-notice block mt-[6px] text-[12px]">
                          {`Get ${formatPriceNumberWithSymbol(vipEquity.vip_v0_coupon, currency)} off and earn points to redeem future orders`}
                        </span>
                      )}
                    </div>
                    <div
                      className="join-btn w-[48px] h-[20px] text-center leading-[22px] bg-gradient-to-r from-[#FFF0D1] to-[#F3CFA0] font-bb rounded-[10px] text-[12px] font-b cursor-pointer"
                      onClick={() => {
                        setJoinFreeDialogInfo({
                          show: true,
                        });
                      }}
                    >
                      {t('join')}
                    </div>
                  </div>
                  <div className="my-points flex items-center h-[49px] px-[12px] notranslate">
                    <div className="disabled-checked h-[16px] w-[16px] box-border border border-[#AAAAAA] bg-[rgba(153,153,153,0.1)] rounded-[50%] transform -translate-y-[1px]" />
                    <span className="points-num ml-[6px] text-[14px] text-[#333333]">
                      {t('Points')}: {price?.point}
                    </span>
                    <span className="points-money ml-auto text-[#333333] font-bold text-[14px]">
                      -{formatPriceNumberWithSymbol(price?.point_discount, currency)}
                    </span>
                  </div>
                </div>
              )}
              {joinMemberSwitch === 2 && (
                <div className="left flex items-center px-[12px]">
                  <span className="ml-[6px]">
                    {t('points')} ({t('joinZeeloolRewards')})
                  </span>
                </div>
              )}
            </div>
          ) : (
            <div
              className="coupon notranslate p-[18px_12px]"
              onClick={() => {
                if (price?.expend_point === 0 || userInfo.is_member !== 1) {
                  return;
                }
                setOpen(true);
              }}
            >
              <div className="flex justify-between items-center">
                <div className="left flex items-center">
                  <Image src="/payment/points.png" alt="points" width={20} height={20} />
                  <span className="text-[14px] ml-8 font-br">
                    {t('points')}{' '}
                    <span
                      className={`text-[14px] font-br ${price?.expend_point > 0 ? 'text-warning' : ''}`}
                    >
                      ({price?.expend_point > 1 ? t('availablePoints') : t('availablePoint')}:{' '}
                      {price?.expend_point})
                    </span>
                  </span>
                </div>
                <div className="right flex items-center text-[14px]">
                  {price?.expend_point === 0 && (
                    <span className="font-bs text-secondary-text">{t('NotAvailable')}</span>
                  )}
                  {checked && price?.point_discount && (
                    <span className="text-warning font-bs">
                      -{formatPriceNumberWithSymbol(price?.point_discount, currency)}
                    </span>
                  )}
                  {price?.expend_point > 0 && <RightArrowOutlined />}
                </div>
              </div>
            </div>
          )}
        </div>

        <Popup
          open={open}
          onClose={() => setOpen(false)}
          showDivider
          title={
            <div className="flex items-center justify-between px-[22px] py-[18px] border-b border-[#E5E5E5]">
              <h3 className="font-bb text-16">{t('points')}</h3>

              <div className="flex items-center">
                <div
                  className="text-12 text-secondary-text mr-16"
                  onClick={() => setShowPointDialog(true)}
                >
                  {t('pointsRuler')}
                </div>
                <CloseOutlined className="text-28 cursor-pointer" onClick={() => setOpen(false)} />
              </div>
            </div>
          }
          height="50vh"
          // sx={{ '& .popup-content': { p: 0 } }}
        >
          <div>
            {/* 积分card */}
            <div
              className={`flex justify-around items-center mx-auto my-4 mb-[135px] py-22 px-18 box-border rounded-[6px] border ${
                tempChecked
                  ? 'border-[#463ae8] shadow-[0px_2px_5px_0px_#C4CEE6] bg-[#E3EBFF]'
                  : 'border-[#ccc]'
              }`}
              onClick={() => {
                if (price?.expend_point) {
                  setTempChecked(!tempChecked);
                }
              }}
            >
              {price?.expend_point && (
                <div className="flex flex-col justify-normal items-normal">
                  <p
                    className={`mb-[10px] text-[#333333] font-bb ${IS_DE_FR ? '' : 'text-[16px]'}`}
                    style={IS_DE_FR ? { fontSize: '16px' } : {}}
                  >
                    {price.expend_point}{' '}
                    {price.expend_point > 1 ? t('pointsRedeem') : t('pointRedeem')}{' '}
                    <span className="notranslate font-bb text-[#b06814]">
                      {formatPriceNumberWithSymbol(price.point_discount, currency)}
                    </span>
                  </p>
                  <span className="text-[14px] mt-[6px] text-auxiliary-text">
                    ({t('myPoints')} {price.point})
                  </span>
                  {price.pointRule?.deduct && (
                    <span className="text-[14px] mt-[6px] text-auxiliary-text">
                      {t('Every')} {price.pointRule.deduct.ratio}{' '}
                      {price.pointRule.deduct.ratio > 1 ? t('points') : t('point')} = US $1
                    </span>
                  )}
                </div>
              )}
              <Checkbox
                checked={tempChecked}
                icon={
                  isDisabledUsePoints ? (
                    <div className="w-[20px] h-[20px] bg-[#edf2fc] rounded-[50%]" />
                  ) : (
                    <div className="w-[20px] h-[20px] rounded-[50%] border-[1.5px] border-[#A9A9A9]" />
                  )
                }
                checkedIcon={
                  <SuccessFilled
                    className="w-[20px] h-[20px]"
                    style={{ width: '20px', height: '20px' }}
                  />
                }
              />
            </div>
            {/* button */}

            <div className="absolute bottom-20 left-0 w-full px-[16px]">
              <Button
                className="w-full"
                onClick={() => {
                  // Confirm the selection: apply points only now
                  onUsePoints(tempChecked);
                  setChecked(tempChecked);
                  setOpen(false);
                }}
                sx={{
                  height: '40px',
                  backgroundColor: 'var(--color-primary-purple)',
                  borderRadius: '20px',
                  width: '100%',
                  color: 'var(--color-primary-white)',
                  fontSize: '14px',
                  fontFamily: 'var(--font-bricolage-bold)',
                }}
              >
                {t('Submit')}
              </Button>
            </div>
          </div>
        </Popup>
      </WapOnly>
      <PointDialog open={showPointDialog} onClose={() => setShowPointDialog(false)} />

      <JoinFreeDialog onSuccess={onJoinFreeSuccess} />
    </div>
  );
}
